import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'

interface PrivateRouteProps {
  user: any
  children: ReactNode
}

export default function PrivateRoute({ user, children }: PrivateRouteProps) {
  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full text-center">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="w-16 h-16 bg-education/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-education" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Acceso Restringido</h2>
            <p className="text-gray-600 mb-6">
              Esta seccion es solo para socios registrados. Unete a nuestra comunidad para acceder a todo el contenido.
            </p>
            <div className="space-y-3">
              <a
                href="/registro"
                className="block w-full bg-education text-white py-3 px-6 rounded-lg font-semibold hover:bg-education/90 transition-colors"
              >
                Hacerte socio gratis
              </a>
              <a
                href="/login"
                className="block w-full bg-white text-education border-2 border-education py-3 px-6 rounded-lg font-semibold hover:bg-education/5 transition-colors"
              >
                Iniciar sesion
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
